import React from 'react';
import { LeafIcon, RecycleIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { collections, materials, type MaterialId } from '../../data/collectes';
const icons: Record<MaterialId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  ordures: Trash2Icon,
  organiques: LeafIcon,
  verts: SproutIcon
};
const MAX_VISIBLE = 3;
export function CollectionList() {
  const [next, ...upcoming] = collections;
  const NextIcons = next.materials.slice(0, MAX_VISIBLE);
  return <section aria-labelledby="collectes-titre" data-id="element-738" data-mp="tx1ktqddxqey">
      <h2 id="collectes-titre" className="sr-only" data-id="element-739" data-mp="tvqbzc531sgz">
        Vos prochaines collectes
      </h2>

      <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-740" data-mp="eyzcz3zbmirw">
        {/* Next collection — primary */}
        <article className="flex flex-col gap-6 rounded-3xl bg-ville-navy p-7 text-white shadow-xl shadow-ville-navy/20 sm:col-span-2 sm:flex-row sm:items-center sm:justify-between sm:gap-10" data-id="element-741" data-mp="jxkbmyyxcue8">
          <div className="min-w-0" data-id="element-742" data-mp="34pvytducezq7">
            <p className="text-3xl font-extrabold leading-tight tracking-tight" data-id="element-743" data-mp="34n02tv222l4e">{next.weekday}</p>
            <p className="mt-1 text-sm text-white/70" data-id="element-744" data-mp="2tj5hfxymft3v">{next.date}</p>
            <span className="mt-3 inline-flex w-fit items-center gap-2 rounded-full bg-ville-lime px-3 py-1 text-xs font-bold uppercase tracking-wider text-ville-navy" data-id="element-745" data-mp="2oj9iwe8p0tvp">
              Collecte en cours
            </span>
          </div>

          <ul className="flex shrink-0 items-start justify-between gap-2 sm:justify-end sm:gap-6" data-id="element-746" data-mp="2xkzapl6hluu0">
            {NextIcons.map(id => {
            const Icon = icons[id];
            return <li key={id} className="flex min-w-0 flex-1 flex-col items-center text-center sm:w-20 sm:flex-none" data-id="element-747" data-mp="37ezmu706s0c8">
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-white/10 text-ville-lime" aria-hidden="true" data-id="element-748" data-mp="3h75d9casi9pb">
                    <Icon className="h-5 w-5" data-id="element-749" data-mp="3q8v70os59kq9" />
                  </span>
                  <span className="mt-2 text-[11px] font-bold leading-tight text-white" data-id="element-750" data-mp="2nuoysqqljgnj">
                    {materials[id].label}
                  </span>
                </li>;
          })}
          </ul>
        </article>

        {/* Following collections */}
        {upcoming.map(collection => {
        const visible = collection.materials.slice(0, MAX_VISIBLE);
        const extra = collection.materials.length - visible.length;
        return <article key={collection.id} className="flex flex-col rounded-3xl border border-slate-200 bg-white p-7" data-id="element-751" data-mp="3bj85j1tzzldi">
              <span className="text-xs font-bold uppercase tracking-wider text-ville-blue" data-id="element-752" data-mp="3fkjvx9kp4amr">Collecte suivante</span>
              <p className="mt-2 text-xl font-extrabold leading-tight text-ville-navy" data-id="element-753" data-mp="3kj3nbpi26emi">
                {collection.weekday} {collection.date}
              </p>

              <ul className="mt-6 flex items-start justify-between gap-2" data-id="element-754" data-mp="1q65b30cst7wj">
                {visible.map(id => {
              const Icon = icons[id];
              return <li key={id} className="flex min-w-0 flex-1 flex-col items-center text-center" data-id="element-755" data-mp="1iofntecmqeh6">
                      <span className="grid h-11 w-11 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-756" data-mp="1du32szvi8v3b">
                        <Icon className="h-5 w-5" data-id="element-757" data-mp="21lgvj6xkisot" />
                      </span>
                      <span className="mt-2 text-[11px] font-bold leading-tight text-ville-navy" data-id="element-758" data-mp="21je18apdudea">
                        {materials[id].label}
                      </span>
                    </li>;
            })}
                {extra > 0 && <li className="flex min-w-0 flex-1 flex-col items-center text-center" data-id="element-759" data-mp="1nkxn3yp6xkm4">
                    <span className="grid h-11 w-11 place-items-center rounded-full border border-dashed border-slate-300 text-sm font-bold text-ville-deep" data-id="element-760" data-mp="g972dqwk6cil">
                      +{extra}
                    </span>
                    <span className="mt-2 text-[11px] font-bold leading-tight text-slate-500" data-id="element-761" data-mp="201nmjy3ecmaf">
                      {extra > 1 ? 'collectes' : 'collecte'}
                    </span>
                  </li>}
              </ul>
            </article>;
      })}
      </div>
    </section>;
}